import { AppComponent } from 'src/app/app.component';
import {
  Component,
  EventEmitter,
  Inject,
  Input,
  OnChanges,
  OnInit,
  Output,
  SimpleChanges,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';

import { NgbPopover } from '@ng-bootstrap/ng-bootstrap';
import { cloneDeep, each, filter } from 'lodash';

import { TICKETS_PATHS } from '../../../../../../tickets/tickets';
import { Enums } from '../../../../../../../configs/Enums';
import { AuthService } from '../../../../../../auth/auth.service';
import { TicketTypesEnum } from '../../../../constants/ticket-types.constant';

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-tickets-brigade-assign-new',
  templateUrl: './tickets-brigade-assign.component.html',
  styleUrls: ['./tickets-brigade-assign.component.scss'],
  standalone: false,
})
export class TicketsBrigadeAssignComponent implements OnInit, OnChanges {
  public TICKETS_PATHS = TICKETS_PATHS;
  public isCanAssignTicket = false;
  public moment = require('moment');
  public Enums = Enums;
  public brigadeLoading = false;
  public brigadeError = null;
  public brigadesDefault = null;
  public brigades = null;
  public searchText = null;
  public isChange = false;
  public isAssign = false;
  public isLeaveCurrent = false;
  public scheduleDate: string;

  @Input() ticket;
  @Input() filter;
  @Input() brigadeAssign;
  @Input() ticketsCurrentFilter;
  @Input() ticketsMultipleAssign;
  // TODO index не применять, ибо сделано под один кейс(.
  @Input() index;
  @Output() onOpen = new EventEmitter<any>();
  @ViewChild('p2') popover: NgbPopover;

  constructor(
    @Inject(AppComponent) private appComp: AppComponent,
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.makeConstants();
  }

  get isGRS() {
    return this.authService.isGRSUser();
  }

  public ngOnChanges(changes: SimpleChanges) {
    if (changes && changes.ticketsCurrentFilter && changes.ticketsCurrentFilter.currentValue) {
      this.makeConstants();
    }

    if (changes && changes.ticketsMultipleAssign && changes.ticketsMultipleAssign.currentValue && !changes.ticketsMultipleAssign.firstChange) {
      this.makeConstants();
    }
  }

  private makeConstants() {
    const ticketVKStatus = this.ticket.ticket_status.id;
    const ticketHDStatus = this.ticket.hd_ticket_status.id;
    // --- Новая, упрощенная логика ---
    // Теперь возможность назначить или изменить заявку определяется только ее статусом.
    // Кнопки доступны, если заявка не находится в финальном статусе (6 - "Отменена" или 8 - "Выполнена").
    // И НЕ в статусе HD=194 и ВК=12
    // Это дает больше гибкости и решает проблему с исчезновением кнопок при фильтрации "на завтра".
    this.isCanAssignTicket =
      (this.authService.isGRSUser() && this.ticket.ticket_type.id === TicketTypesEnum.GlobalProblemGRS) ||
      (ticketVKStatus !== 6 && ticketVKStatus !== 8 && !(ticketHDStatus === 194 && ticketVKStatus === 12));
    // --- Старая логика проверки по дате (закомментирована на случай, если понадобится) ---
    // Была слишком строгой и не позволяла назначать/изменять заявки,
    // если их интервал не пересекался с вычисленным "окном назначения".
    /*
  const dateShortFormat = Enums.dates.shortFormat;
  const ticketScheduleDate = this.moment(this.ticket.hd_schedule_date).valueOf();
  const ticketScheduleEndDate = this.moment(this.ticket.hd_schedule_intend).valueOf();
  const ticketScheduleBeginDate = this.moment(this.ticket.hd_schedule_intbegin).valueOf();
  const ticketEsasType = this.ticket.ticket_type.id;
  const daysAssignLimit = (this.ticketsCurrentFilter && this.ticketsCurrentFilter.ticketsSettings && this.ticketsCurrentFilter.ticketsSettings.days_for_assignment) || 2;
  const workingDateAssign = this.ticketsCurrentFilter && this.ticketsCurrentFilter.ticketsSettings && this.ticketsCurrentFilter.ticketsSettings.tomorrow_assignment_time;
  const countDaysAdd = this.ticketsCurrentFilter && this.ticketsCurrentFilter.ticketsSettings && this.ticketsCurrentFilter.assignDaySelected.countDays;
  const firstAssignDate = this.moment(this.moment(workingDateAssign).add(countDaysAdd, 'day').format(dateShortFormat)).startOf('day').valueOf();
  const endAssignDate = this.moment(this.moment(workingDateAssign).format(dateShortFormat))
    .add(daysAssignLimit + countDaysAdd, 'day')
    .endOf('day')
    .valueOf();

  // Предыдущая проверка:
  this.isCanAssignTicket =
    (this.authService.isGRSUser() && this.ticket.ticket_type.id === TicketTypesEnum.GlobalProblemGRS) ||
    (ticketVKStatus !== 6 && ticketVKStatus !== 8 && ticketScheduleBeginDate <= endAssignDate && ticketScheduleEndDate >= firstAssignDate);
  */

    // Иначе (tt == 5), то (hd_schedule_intend >= firstAssignDate
    //     && hd_schedule_intbegin <= endAssignDate && ticketVKStatus !== 6)

    this.isChange = this.ticket.ticket_status && this.ticket.ticket_status.id !== 6 && this.ticket.ticket_status.id !== 8;
    this.isAssign = !!this.ticket.brigade;
    this.isLeaveCurrent = this.ticket.ticket_status && this.ticket.ticket_status.id === 5;
  }

  private makeBrigade(): void {
    const dateFullFormat = Enums.dates.fullFormat;
    let currentFilter = this.ticketsCurrentFilter;
    let dayContext = currentFilter.assignDaySelected;

    this.scheduleDate = this.moment(currentFilter.ticketsSettings.tomorrow_assignment_time).add(dayContext.countDays, 'day').startOf('day').format(dateFullFormat);
    this.brigadesDefault = cloneDeep(this.ticketsMultipleAssign.brigades);

    each(this.brigadesDefault, (brigade) => {
      brigade.workers = [];

      if (brigade.trainee_users_count > 0) {
        for (let i = 0; i < brigade.trainee_users_count; i++) {
          brigade.workers.push({ type: 1 });
        }
      }

      if (brigade.primary_users_count > 0) {
        for (let i = 0; i < brigade.primary_users_count; i++) {
          brigade.workers.push({ type: 2 });
        }
      }
    });

    this.brigades = this.ticket.brigade ? filter(this.brigadesDefault, (brigade: any) => brigade.id !== this.ticket.brigade.id) : this.brigadesDefault;
  }

  public onChangeBrigade(ticket, brigade, type): void {
    if (type === 'remove') {
      this.brigadeAssign.removeBrigade({
        ticket_id: ticket.id,
        ticket_number: ticket.hd_ticket_number,
        brigade_id: null,
        schedule_date: this.scheduleDate,
        sector_id: this.filter.sectorSelected.sector_id,
        brigade_old_id: ticket.brigade.brigade_id || ticket.brigade.id,
      });
      ticket.brigade = null;
    } else {
      this.brigadeAssign.addBrigade({
        ticket_id: ticket.id,
        ticket_number: ticket.hd_ticket_number,
        brigade_id: brigade.id,
        ticket_type: ticket.ticket_type,
        schedule_date: this.scheduleDate,
        sector_id: this.filter.sectorSelected.sector_id,
      });
      ticket.brigade = {
        id: brigade.id,
        brigade_name: brigade.brigade_name,
      };
    }

    this.makeConstants();
    this.popover.close();
    this.appComp.update();
  }

  public toggleWithBrigadeContext(popover: NgbPopover): void {
    if (popover.isOpen()) {
      popover.close();
      this.onOpen.emit({ state: false, ticket: this.ticket });
    } else {
      popover.open();
      this.makeBrigade();
      this.onOpen.emit({ state: true, ticket: this.ticket });
    }

    this.appComp.update();
  }

  // Открыть попап назначения программно (используется при клике по названию бригады)
  public openPopover(): void {
    if (!this.popover) return;
    if (!this.popover.isOpen()) {
      this.makeBrigade();
      this.popover.open();
      this.onOpen.emit({ state: true, ticket: this.ticket });
      this.appComp.update();
    }
  }
}
